export interface AdditionalPropertyInfo {
  name?: string;
  year: string;
  sqft?: string;
  lot?: string;
  attomId?: number;
  baths: number;
  beds: number;
  images?: string[];
  geoLocation?: string; // "POINT (lat:number, long: number)""
  propertyType?: string;
  owner: {
    first: string;
    last: string;
    address: string;
  };
  mortgage: {
    lender: string;
    titleCompany: string;
    amount: number;
  };
}
